import React, { Fragment, useEffect, useState } from "react";
import {
  ViedocMenuItemElement,
  ViedocRadioElement,
  ViedocSelectElement,
} from "../../../../secure/elements/ViedocReactElements";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import _ from "underscore";

const LocationLevelSetting = ({
  label,
  type,
  locationArray,
  settingsObject,
  sendRolesAndAccessData,
  sendMilestone,
  sendDocument,
  showWarnings,
  RadioFieldRequired,
  RadioFieldOPtional,
  RadioFieldNotPermitted,
  selectedMilestoneValue,
  selectedRolesAndAccess
}) => {
  const { t } = useTranslation();
  const { mileStoneList, viewDialog } = useSelector((store) => store.template);
  const { countrylevelsetting, sitelevelsetting, triallevelsetting } =
    viewDialog.artifactData;
  const defaultNotPermitted =
    !RadioFieldRequired && !RadioFieldOPtional && !RadioFieldNotPermitted;
  const [isRequired, setIsRequired] = useState(RadioFieldRequired);
  const [isOptional, setIsOptional] = useState(RadioFieldOPtional);
  const [isNotPermitted, setIsNotPermitted] = useState(
    defaultNotPermitted || RadioFieldNotPermitted
  );

  const trialLevelRoles = [
    ...triallevelsetting?.rolesaccesses?.map((roles) => ({
      roleType: roles.name.replace("Role ", ""),
      access: roles.access,
    })),
  ];

  const countryLevelRoles = [
    ...countrylevelsetting?.rolesaccesses?.map((roles) => ({
      roleType: roles.name.replace("Role ", ""),
      access: roles.access,
    })),
  ];

  const siteLevelRoles = [
    ...sitelevelsetting?.rolesaccesses?.map((roles) => ({
      roleType: roles.name.replace("Role ", ""),
      access: roles.access,
    })),
  ];

  const rolesArray =
    type === "trial"
      ? trialLevelRoles
      : type === "country"
      ? countryLevelRoles
      : siteLevelRoles;

  const [siteStaffAccess, setSiteStaffAccess] = useState(
    selectedRolesAndAccess?.find((role) => role.userRole === "SITESTAFF").access
  );
  const [sponsorStudyAccess, setSponsorStudyAccess] = useState(
    selectedRolesAndAccess?.find((role) => role.userRole === "SPONSOR-STUDY").access
  );
  const [sponsorCountryAccess, setSponsorCountryAccess] = useState(
    selectedRolesAndAccess?.find((role) => role.userRole === "SPONSOR-COUNTRY").access
  );
  const [sponsorSiteAccess, setSponsorSiteAccess] = useState(
    selectedRolesAndAccess?.find((role) => role.userRole === "SPONSOR-SITE").access
  );
  const [sponsorReviewAccess, setSponsorReviewAccess] = useState(
    selectedRolesAndAccess?.find((role) => role.userRole === "SPONSOR-REVIEW").access
  );

  const [sponsorDmAccess, setSponsorDmAccess] = useState(
    selectedRolesAndAccess?.find((role) => role.userRole === "SPONSOR-DM").access
  );

  const [sponsorUnblindedAccess, setSponsorUnblindedAccess] = useState(
    selectedRolesAndAccess?.find((role) => role.userRole === "SPONSOR-UNBLINDED").access
  );

  const PERMISSION_ARRAY = [
    {
      label: t("ADMIN.TEXT_NOACCESS"),
      value: "NO ACCESS",
    },
    {
      label: t("ADMIN.TEXT_READ"),
      value: "READ",
    },
    {
      label: t("ADMIN.TEXT_WRITE"),
      value: "WRITE",
    },
    {
      label: t("ADMIN.TEXT_REVIEW"),
      value: "REVIEW",
    },
  ];

  const rolesAccessArray = [
    { roleType: "SITESTAFF", access: siteStaffAccess },
    { roleType: "SPONSOR-STUDY", access: sponsorStudyAccess },
    { roleType: "SPONSOR-COUNTRY", access: sponsorCountryAccess },
    { roleType: "SPONSOR-SITE", access: sponsorSiteAccess },
    { roleType: "SPONSOR-REVIEW", access: sponsorReviewAccess },
    { roleType: "SPONSOR-DM", access: sponsorDmAccess },
    { roleType: "SPONSOR-UNBLINDED", access: sponsorUnblindedAccess },
  ];
  const [selectedMilestone, setSelectedMilestone] = useState(
    mileStoneList.find(
      (milestone) => selectedMilestoneValue === milestone.id
    )?.name
  );

  let requestPayload = [];

  const getUserScope = () => {
    return type === "trial" ? "Study" : type === "country" ? "Country" : "Site";
  };

  useEffect(() => {
    createRolesAndAccessPayload();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setSelectedMilestone(
      mileStoneList.find(
        (milestone) => selectedMilestoneValue === milestone.id
      )?.name
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mileStoneList]);

  useEffect(() => {
    setIsRequired(RadioFieldRequired);
    setIsOptional(RadioFieldOPtional);
    setIsNotPermitted(defaultNotPermitted || RadioFieldNotPermitted);
    setSelectedMilestone(
      mileStoneList?.find(
        (milestone) => selectedMilestoneValue === milestone.id
      )?.name
    );
    setSiteStaffAccess(
      selectedRolesAndAccess?.find((role) => role.userRole === "SITESTAFF").access
    );
    setSponsorStudyAccess(
      selectedRolesAndAccess?.find((role) => role.userRole === "SPONSOR-STUDY").access
    );
    setSponsorCountryAccess(
      selectedRolesAndAccess?.find((role) => role.userRole === "SPONSOR-COUNTRY").access
    );
    setSponsorSiteAccess(
      selectedRolesAndAccess?.find((role) => role.userRole === "SPONSOR-SITE").access
    );
    setSponsorReviewAccess(
      selectedRolesAndAccess?.find((role) => role.userRole === "SPONSOR-REVIEW").access
    );
    setSponsorDmAccess(
      selectedRolesAndAccess?.find((role) => role.userRole === "SPONSOR-DM").access
    );
    setSponsorUnblindedAccess(
      selectedRolesAndAccess?.find((role) => role.userRole === "SPONSOR-UNBLINDED").access
    );
  }, [
    RadioFieldRequired,
    RadioFieldOPtional,
    RadioFieldNotPermitted,
    defaultNotPermitted,
    selectedMilestoneValue,
    selectedRolesAndAccess,
  ]);

  const createRolesAndAccessPayload = (roleType, value) => {
    requestPayload = [
      {
        userRole: "SITESTAFF",
        userScope: getUserScope(),
        access: roleType === "SITESTAFF" ? value : siteStaffAccess,
      },
      {
        userRole: "SPONSOR-STUDY",
        userScope: getUserScope(),
        access: roleType === "SPONSOR-STUDY" ? value : sponsorStudyAccess,
      },
      {
        userRole: "SPONSOR-COUNTRY",
        userScope: getUserScope(),
        access: roleType === "SPONSOR-COUNTRY" ? value : sponsorCountryAccess,
      },
      {
        userRole: "SPONSOR-SITE",
        userScope: getUserScope(),
        access: roleType === "SPONSOR-SITE" ? value : sponsorSiteAccess,
      },
      {
        userRole: "SPONSOR-REVIEW",
        userScope: getUserScope(),
        access: roleType === "SPONSOR-REVIEW" ? value : sponsorReviewAccess,
      },
      {
        userRole: "SPONSOR-DM",
        userScope: getUserScope(),
        access: roleType === "SPONSOR-DM" ? value : sponsorDmAccess,
      },
      {
        userRole: "SPONSOR-UNBLINDED",
        userScope: getUserScope(),
        access:
          roleType === "SPONSOR-UNBLINDED" ? value : sponsorUnblindedAccess,
      },
    ];
  };

  const spanFunc = () => {
    return <span style={{ color: "#CC4E00" }}>*</span>;
  };

  const documentRadioButtonsArray = [
    {
      id: 1,
      checkedValue: isRequired,
      location: "Required",
      label: t("ADMIN.TEXT_REQUIRED"),
      type: type,
    },
    {
      id: 2,
      checkedValue: isOptional,
      location: "Optional",
      label: t("ADMIN.TEXT_OPTIONAL"),
      type: type,
    },
    {
      id: 3,
      checkedValue: isNotPermitted,
      location: "Not permitted",
      label: t("ADMIN.TEXT_NOTPERMITTED"),
      type: type,
    },
  ];

  const radioButtonHandler = (location) => {
    switch (location) {
      case "Not permitted":
        setIsNotPermitted(true);
        setIsRequired(false);
        setIsOptional(false);
        sendDocument("Not permitted", type);
        break;

      case "Required":
        setIsNotPermitted(false);
        setIsRequired(true);
        setIsOptional(false);
        sendDocument("Required", type);
        break;

      case "Optional":
        setIsNotPermitted(false);
        setIsRequired(false);
        setIsOptional(true);
        sendDocument("Optional", type);
        break;

      default:
        return;
    }
  };

  const permissionHandler = (event, roleType) => {
    let value = event.target.value;
    switch (roleType) {
      case "SITESTAFF":
        setSiteStaffAccess(value);
        break;

      case "SPONSOR-STUDY":
        setSponsorStudyAccess(value);
        break;

      case "SPONSOR-COUNTRY":
        setSponsorCountryAccess(value);
        break;

      case "SPONSOR-SITE":
        setSponsorSiteAccess(value);
        break;

      case "SPONSOR-REVIEW":
        setSponsorReviewAccess(value);
        break;

      case "SPONSOR-DM":
        setSponsorDmAccess(value);
        break;

      case "SPONSOR-UNBLINDED":
        setSponsorUnblindedAccess(value);
        break;

      default:
        break;
    }
    createRolesAndAccessPayload(roleType, value);
    sendRolesAndAccessData(requestPayload, type);
  };

  const selectedMilestoneHandler = (event) => {
    setSelectedMilestone(event.target.value);
    sendMilestone(
      mileStoneList.find((milestone) => event.target.value === milestone.name)
        ?.id,
      type
    );
  };

  const renderRolesAndMilestones = () => {
    return (
      <>
        <div
          className="d-flex pad-5 align-center roles-wrapper"
          style={{
            display: !documentRadioButtonsArray[2].checkedValue
              ? "flex"
              : "none",
          }}
        >
          <div className="w-25 text-right pr-15 gray-60 fw-400">
            {`${t("ADMIN.ADMINTAB_ROLES")} ${t("TMF.TEXT_AND")} ${t(
              "ADMIN.ADMINTAB_ACCESSES"
            )}`}
            {spanFunc()}
          </div>
          {rolesAccessArray.map((roles, index) => (
            <Fragment key={roles.roleType}>
              <div
                className={
                  index === 0 ? "rolesandaccess" : "rolesandaccess mt-10"
                }
              >
                <div className="role-wise">
                  <viedoc-textfield
                    class="disabled_input w-220"
                    size="small"
                    variant="outline"
                  >
                    <input type="text" value={roles.roleType} disabled />
                  </viedoc-textfield>
                  <div className="tmfside-checkbox w-220">
                    <ViedocSelectElement
                      size="small"
                      value={roles.access}
                      onChange={(e) => permissionHandler(e, roles.roleType)}
                    >
                      {PERMISSION_ARRAY.map((permission, index) => (
                        <ViedocMenuItemElement
                          key={index}
                          value={permission.value}
                          size="medium"
                        >
                          {permission.label}
                        </ViedocMenuItemElement>
                      ))}
                    </ViedocSelectElement>
                  </div>
                </div>
              </div>
              <div className="w-25 text-right pr-15 gray-60 fw-400"></div>
            </Fragment>
          ))}
        </div>

        <div
          className="d-flex pad-5 align-center"
          style={{
            display: !documentRadioButtonsArray[2].checkedValue
              ? "flex"
              : "none",
          }}
        >
          <div className="w-25 text-right pr-15 gray-60 fw-400 ">
            {t("ADMIN.ADMINTAB_MILESTONE")}
            {spanFunc()}
          </div>
          <div
            className={
              showWarnings && _.isEmpty(selectedMilestone)
                ? "w-450 tmfside-checkbox warning"
                : "w-450 tmfside-checkbox"
            }
          >
            <ViedocSelectElement
              size="small"
              placeholder="Select milestone"
              value={selectedMilestone}
              onChange={(e) => selectedMilestoneHandler(e)}
            >
              {mileStoneList.map((milestone) => (
                <ViedocMenuItemElement
                  key={milestone.id}
                  value={milestone.name}
                  size="medium"
                >
                  {milestone.name}
                </ViedocMenuItemElement>
              ))}
            </ViedocSelectElement>
          </div>
        </div>
      </>
    );
  };

  return (
    <section className="view-artifact-block ff-vmg">
      <article className="sem-pri-color">{label}</article>
      <aside className="d-flex flex-dir-col">
        <div className="pt-10">
          <div className="d-flex pad-5 align-center">
            <div className="w-25 text-right pr-15 gray-60 fw-400">
              {t("COMMON.TEXT_DOCUMENT")}
              {spanFunc()}
            </div>
            <div className="d-flex gap-20 f14">
              {documentRadioButtonsArray.map((document) => (
                <Fragment key={document.id}>
                  <ViedocRadioElement
                    name="documentGroup"
                    value={document.label}
                    checked={document.checkedValue}
                    className="tmfside-checkbox"
                    onChange={() => radioButtonHandler(document.location)}
                  >
                    {document.label}
                  </ViedocRadioElement>
                </Fragment>
              ))}
            </div>
          </div>
          {renderRolesAndMilestones()}
        </div>
      </aside>
    </section>
  );
};

export default LocationLevelSetting;
